// Fase 26 · Orden estricto del menú lateral solicitado por el cliente:
// 1. Motor Creativo, 2. Chat Interno, 3. WhatsApp, 4. Email Marketing,
// 5. Messenger, 6. Instagram, 7. Facebook, 8. TikTok, 9. YouTube,
// 10. Página Facebook, 11. Marketplace, 12. MercadoLibre.
export const MODULES = [
  { key: "motor_creativo", label: "Motor Creativo", icon: "Sparkles", path: "/motor-creativo" },
  { key: "chat_interno", label: "Chat interno", icon: "MessageCircle", path: "/chat" },
  { key: "whatsapp", label: "WhatsApp", icon: "MessageCircle", path: "/whatsapp" },
  { key: "email_marketing", label: "Email Marketing", icon: "Mail", path: "/email-marketing" },
  { key: "messenger", label: "Messenger", icon: "MessageSquare", path: "/messenger" },
  { key: "instagram", label: "Instagram", icon: "Instagram", path: "/instagram" },
  { key: "facebook", label: "Facebook", icon: "Facebook", path: "/facebook" },
  { key: "tiktok", label: "TikTok", icon: "Music2", path: "/tiktok" },
  { key: "youtube", label: "YouTube", icon: "Youtube", path: "/youtube" },
  { key: "meta_pages", label: "Página Facebook", icon: "Newspaper", path: "/meta-pages" },
  { key: "marketplace", label: "Marketplace", icon: "ShoppingBag", path: "/marketplace" },
  { key: "mercadolibre", label: "MercadoLibre", icon: "Home", path: "/mercadolibre" },
];

export const SOCIAL_PLATFORMS = [
  {
    key: "instagram",
    label: "Instagram",
    icon: "Instagram",
    module: "instagram",
    path: "/instagram",
    kind: "post",
    accent: "#E1306C",
    placeholderHandle: "@usuario",
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: "Facebook",
    module: "facebook",
    path: "/facebook",
    kind: "post",
    accent: "#1877F2",
    placeholderHandle: "Nombre de página",
  },
  {
    key: "tiktok",
    label: "TikTok",
    icon: "Music2",
    module: "tiktok",
    path: "/tiktok",
    kind: "post",
    accent: "#000000",
    placeholderHandle: "@usuario",
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    icon: "MessageCircle",
    module: "whatsapp",
    path: "/whatsapp",
    kind: "message",
    accent: "#25D366",
    placeholderHandle: "+50412345678 · WhatsApp Business",
  },
];

export const ROLE_LABELS = {
  master: "Master",
  admin: "Administrador",
  agente: "Agente",
  creativo: "Creativo",
};

export const ROLES = ["master", "admin", "agente", "creativo"];

export const POST_STATUS_LABELS = {
  draft: "Borrador",
  scheduled: "Programada",
  published: "Publicada",
  failed: "Fallida",
};

export const ACTION_LABELS = {
  login_success: "Inicio de sesión exitoso",
  login_failed: "Intento fallido",
  login_blocked: "Acceso bloqueado (inactivo)",
  logout: "Cierre de sesión",
  user_created: "Usuario creado",
  user_updated: "Usuario actualizado",
  user_deleted: "Usuario eliminado",
  password_reset: "Contraseña restablecida",
  connection_created: "Cuenta conectada",
  connection_deleted: "Cuenta desconectada",
  post_created: "Publicación creada",
  post_updated: "Publicación editada",
  post_deleted: "Publicación eliminada",
  post_published: "Publicación enviada",
  post_published_scheduler: "Publicada por scheduler",
  company_created: "Empresa creada",
  company_updated: "Empresa actualizada",
  membership_created: "Membresía asignada",
  membership_updated: "Membresía actualizada",
  membership_deleted: "Membresía retirada",
  profile_updated: "Perfil actualizado",
  password_self_changed: "Contraseña cambiada",
  password_change_failed: "Fallo cambio contraseña",
  avatar_updated: "Avatar actualizado",
  avatar_deleted: "Avatar eliminado",
  creative_generated: "Pieza IA generada",
  creative_auto_approved: "Pieza auto-aprobada",
  creative_set_approved: "Set creativo aprobado",
  creative_set_rejected: "Set creativo rechazado",
  report_created: "Reporte guardado",
  report_deleted: "Reporte eliminado",
  report_exported: "Reporte exportado",
};
